<ng-container *ngIf="!isPolicyOnly">
  {{parts.p1}}
  <a class="text-sm hover:text-blue-500" target="_blank" (click)="gotoTermsAndConditions($event)">
    <u>{{parts.a1}}</u>
  </a>
  {{parts.p2}}
</ng-container>

<ng-container *ngIf="isPolicyOnly">
  {{policyLeadText}}
</ng-container>

<span *ngIf="!isTermsOnly">
  <span *ngIf="!isPolicyOnly">
    {{parts.p3}}
  </span>
  <a class="text-sm hover:text-blue-500" target="_blank" (click)="gotoLegalDocument($event)">
    <u>{{parts.a2}}</u>
  </a>
</span>
